// extracted by mini-css-extract-plugin
export default {"block":"Jn","error":"Kn","info":"Ln","noSpace":"Mn"};